// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"652":"82a13959","769":"b1037e3c"}[chunkId] + ".chunk.js";
};